import { Accordion, Badge, Card, Col, Row } from 'react-bootstrap';
import { FaCalendarAlt, FaClock, FaEye } from 'react-icons/fa';
import './SlotView.css';
import {
  useGetB2BSlotList,
  useReservedSlot,
} from '../../apiEndpoints/b2bBuyerSellerEndpoint';
import moment from 'moment';
import { calculateDuration, groupSlotsByDate } from '../utility/b2bUtility';
import { Link } from 'react-router-dom';
import PopOver from '../../../../Components/PopOver/PopOver';

function SlotView({
  type,
  user_id,
}: {
  type: 'B2B' | 'Exhibitor';
  user_id: number;
}) {
  const { data } = useGetB2BSlotList({
    user_id: user_id as number,
    type: type,
  });

  const { mutate } = useReservedSlot({
    user_id: user_id as number,
    type: type,
  });
  const groupedSlots = groupSlotsByDate(data?.data);

  return (
    <>
      <h2 className='text-center mb-4'>
        <FaCalendarAlt className='me-2' />
        Your Available Time Slots
      </h2>

      {groupedSlots && Object?.keys(groupedSlots)?.length === 0 ? (
        <Card className='text-center p-4 no-slots-card'>
          <p className='text-muted'>No time slots created yet</p>
        </Card>
      ) : (
        <Accordion
          defaultActiveKey={groupedSlots && Object?.keys(groupedSlots)[0]}
          flush
        >
          {groupedSlots &&
            Object?.entries(groupedSlots)?.map(([date, dateSlots]) => (
              <Accordion.Item
                eventKey={date}
                key={date}
                className='mb-3 date-card'
              >
                <Accordion.Header>
                  <div className='d-flex justify-content-between w-100 pe-3'>
                    <div>
                      <FaCalendarAlt className='me-2 text-primary' />
                      <strong>
                        {moment(date)?.format('dddd, MMM D, YYYY')}
                      </strong>
                    </div>
                    <Badge bg='primary' pill>
                      {dateSlots.length} slot{dateSlots.length !== 1 ? 's' : ''}
                    </Badge>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <Row>
                    {dateSlots?.map((slot) => (
                      <Col key={slot.id} md={6} lg={4} className='mb-3'>
                        <Card className='time-slot-card h-100'>
                          <div className='p-2'>
                            <div className='d-flex align-items-center mb-2'>
                              <FaClock className='me-2 text-secondary' />
                              <h5 className='mb-0'>
                                {moment(slot.start_time).format('hh:mm A')} -{' '}
                                {moment(slot.end_time).format('hh:mm A')}
                              </h5>
                            </div>
                            <p className='text-muted mb-3'>
                              Duration:{' '}
                              {calculateDuration(
                                slot.start_time,
                                slot.end_time
                              )}
                            </p>
                            <div>
                              <div className='d-flex justify-content-between'>
                                <span className='pointer'>
                                  {slot.is_available === 0 &&
                                    slot.is_reserved === 0 && (
                                      <Badge>Booked</Badge>
                                    )}
                                </span>
                                <Link
                                  to={
                                    slot.type === 'B2B'
                                      ? `/b2b/other-b2b-slot-list?slot_id=${slot.id}`
                                      : `/profile/meeting-request?slot_id=${slot.id}`
                                  }
                                  className='text-decoration-none'
                                >
                                  <FaEye className='me-1' />
                                </Link>
                              </div>
                              {slot.is_available === 1 &&
                                slot.is_reserved === 0 && (
                                  <div className='pointer'>
                                    <PopOver
                                      title='Are you sure to reserved this ?'
                                      confirm={() =>
                                        mutate({
                                          is_reserved:
                                            slot.is_reserved === 0 ? 1 : 0,
                                          slot_id: slot.id,
                                        })
                                      }
                                      children={
                                        <Badge style={{ width: '100%' }}>
                                          Want to Reserve?
                                        </Badge>
                                      }
                                    />
                                  </div>
                                )}
                              {slot.is_available === 0 &&
                                slot.is_reserved === 1 && (
                                  <div
                                    // onClick={() =>
                                    //   mutate({
                                    //     is_reserved:
                                    //       slot.is_reserved === 0 ? 1 : 0,
                                    //     slot_id: slot.id,
                                    //   })
                                    // }
                                    className='text-muted pointer text-center'
                                    style={{
                                      background: '#e3e3e3',
                                      color: 'black',
                                      padding: '2px',
                                      borderRadius: '5px',
                                      width: '100%',
                                    }}
                                  >
                                    Reserved
                                  </div>
                                )}
                            </div>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            ))}
        </Accordion>
      )}
    </>
  );
}

export default SlotView;
